import * as firebase from 'firebase'

/*
  This is just a regular javascript object and no longer is a store.
  It no longer is a store, instead it gets sent to the store file now.
*/
export default {
  // the store configuration
  state: {
    position: {},
    challenges: [],
    pastChallenges: [],
    availableChallengers: [],
    mapCenter: {lat: 33.423650, lng: -111.939623}
  },
  mutations: {  // changes the state of data properties
    setUserPosition (state, payload) {
      state.position = payload
    },
    setChallenges (state, payload) {
      state.challenges = payload
    },
    setPastChallenges (state, payload) {
      state.pastChallenges = payload
    },
    createChallenge (state, payload) {
      state.challenges.push(payload)
    },
    setAvailableChallengers (state, payload) {
      state.availableChallengers = payload
    },
    setMapCenter (state, payload) {
      state.mapCenter = payload
    }
  },
  /*
    Perform all asynchronous tasks in the actions area
   */
  actions: {  // to dispatch the mutations
    fetchUserPosition ({commit, getters}) {
      // get user data from firebase using the getters
      // once fetches the data once.  It doesn't set up a permanent listener
      firebase.database().ref('users').child(getters.user.id).once('value')
        .then((data) => {
          const updatedPosition = {
            latitude: data.child('latitude').val(),
            longitude: data.child('longitude').val()
          }
          commit('setUserPosition', updatedPosition)
        })
        .catch((error) => { console.log(error) })
    },
    loadChallenges ({commit, getters}) {
      firebase.database().ref('challenges').on('value', (data) => {
          const obj = data.val()
          let challenges = []
          const user = getters.user.id

          // loop through the challenges
          for (let key in obj) {
            if (user == obj[key].challengerId || user == obj[key].opponentId) {
              challenges.push({
                key: key,
                accepted: obj[key].opponentHasAccepted,
                opponentRank: obj[key].opponentRank,
                opponentId: obj[key].opponentId,
                opponentFirstName: obj[key].opponentFirstName,
                challengerRank: obj[key].challengerRank,
                challengerId: obj[key].challengerId,
                challengerFirstName: obj[key].challengerFirstName,
                startDate: obj[key].startDate,
                duration: obj[key].duration
              })
            }
          }
          commit('setChallenges', challenges)
        })
    },
    loadPastChallenges({commit}, payload) {
      firebase.database().ref('users').child(payload.uid).child('challengeHistory').on('value', (data) => {
          const obj = data.val()
          const pastChallenges = []

          for (let key in obj) {
            pastChallenges.push({
              user: obj[key].opponentFirstName,
              outcome: obj[key].winnerId,
              key: obj[key].opponentId
            })
          }
          commit('setPastChallenges', pastChallenges)
        })
    },
    loadAvailableChallengers ({commit}, payload) {
      firebase.database().ref('users').on('value', (data) => {
          const obj = data.val()  // store all objects
          let availableChallengers = []
          for (let key in obj) {
            if (key != payload.uid) {
              //typeof will be string if no lat or long stored
              if ((typeof obj[key].latitude == 'number') && (typeof obj[key].longitude == 'number')) {
                if((obj[key].latitude != 0) && (obj[key].longitude != 0)) {
                  const newMarker = {
                    position : {
                      lat: obj[key].latitude,
                      lng: obj[key].longitude
                    },
                    rank: obj[key].rank,
                    name: obj[key].firstName,
                    id: key,
                    clickable: "true"
                  }
                  availableChallengers.push(newMarker)
                }
              }
            }
          }
          commit('setAvailableChallengers', availableChallengers)
        })
    },
    createChallenge({commit, getters}, payload) {
      const challenge = {
        challengerId: getters.user.id,
        challengerRank: getters.user.rank,
        challengerFirstName: getters.user.firstName,
        opponentRank: payload.opponentRank,
        opponentId: payload.opponentId,
        opponentFirstName: payload.opponentFirstName,
        opponentHasAccepted: false,
        startDate: '',
        winnerId: '',
        duration: payload.duration
      }
      firebase.database().ref('challenges').push(challenge)
        .then(() => {
          this.dispatch('loadChallenges')
        })
        .catch((error) => { console.log(error) })
    },
    acceptChallenge({commit}, payload) {
      if (payload.opponentHasAccepted) {
        firebase.database().ref('challenges').child(payload.key).update({
          "opponentHasAccepted": true,
          "startDate": payload.startDate
        })
        .catch((error) => { console.log(error) })
      } else {
        this.dispatch('deleteChallenge', payload.key)
      }
    },
    deleteChallenge({commit}, payload) {
      firebase.database().ref('challenges').child(payload).remove()
        .catch((error) => { console.log(error) })
    },
    loadMapCenter({commit, getters}) {
      //Ensure geolocation services are available and request location permissions
      if (navigator.geolocation) {
        let buffer = null
        if(Math.random()>= 0.5){
          buffer = Math.random()/100;
        }

        navigator.geolocation.getCurrentPosition(function (position) {
          const center = {
              lat: position.coords.latitude,
              lng: position.coords.longitude
          }
          //Set map center to current device location
          commit('setMapCenter', center)

          //Store logged in users location to the DB and update
          firebase.database().ref('users').child(getters.user.id).update({
            longitude: center.lng+buffer,
            latitude: center.lat+buffer
          })
          commit('setUserPosition', {longitude: center.lng+buffer, latitude: center.lng+buffer})
        }.bind(this))
      }
    }
  },
  getters: {  // get the store in pur components
    position (state) {  // return the user from vuex store
      return state.position
    },
    challenges (state) {
      return state.challenges
    },
    pastChallenges (state) {
      return state.pastChallenges.slice(0, 5)
    },
    availableChallengers (state) {
      return state.availableChallengers
    },
    mapCenter (state) {
      return state.mapCenter
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/challenge/index.js